import sendRequest from "@/libs/sendRequest";

export const products = {
    namespaced: true,

    state: {
        data: [],
        total_data: 0,
    },
    getters: {
        getItems: (state) => state.data,
        getTotal: (state) => state.total_data,
    },
    mutations: {
        setItems: (state, payload) => {
            state.data = payload; 
        },
        setTotalItems: (state, payload) => {
            state.total_data = payload; 
        },
    },
    actions: {
        list: async ({ commit, rootGetters }, { isDatatable = true, page = 1, rows = 10, search = '', order_by = 'Id', order_asc = true }) => {
            const custom_headers = rootGetters.getHeaders

            try {
                let query = { isDatatable, page, rows, search, order_by, order_asc }
                const response = await sendRequest(`administrator/heishop/productos/list`, 'GET', null, null, query, custom_headers);

                if(response.success && response.data) {
                    commit('setItems', isDatatable ? response.data.list.result : response.data.list)
                    commit('setTotalItems', isDatatable ? response.data.list.total_rows : 1)
                }
                else if(!response.success &&  response.error) {
                    dispatch('showError', 'Un error ha ocurrido intente más tarde', { root: true })
                }
                else {
                    dispatch('showError', 'Un error ha ocurrido intente más tarde', { root: true })
                }
            }
            catch (error) {
                console.error('Error en la solicitud:', error);
            }
        },
        add: async ({ dispatch, rootGetters }, { data }) => {
            const custom_headers = rootGetters.getHeaders; 
            try {
                const response = await sendRequest(`administrator/heishop/productos/add`, 'POST', null, data, null, custom_headers);

                if (response.success) {
                    await dispatch('list'); 
                    return response;
                } else {
                    throw new Error(response.errors ? response.errors[0].message : 'Error desconocido');
                }
            } catch (error) {
                console.error('Error al agregar el registro:', error);
                throw error; 
            }
        }
    },
};